/**
 * @return {boolean} TRUE if current window is an iframe window
 */
export function checkIsIframe() {
	return window !== window.top;
}

const _isMobile = ('orientation' in window) || (navigator.userAgent.indexOf('IEMobile') !== -1);
const _isTouchScreen = ('ontouchstart' in window || navigator.msMaxTouchPoints);

export function isMobile() {
	return _isMobile;
}

export function isTouchScreen() {
	return _isTouchScreen;
}

export const WEBP_FEATURES = {
	LOSSY: 'lossy',
	LOSSLESS: 'lossless',
	ALPHA: 'alpha',
	ANIMATION: 'animation'
};

export function isWebpFeatureSupported(feature) {
	return new Promise((resolve, reject) => {
		if (!Object.values(WEBP_FEATURES).includes(feature)) {
			reject('Invalid feature name');
			return;
		}

		const kTestImages = {
			lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
			lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
			alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
			animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
		};
		const img = new Image();
		img.onload = () => {
			const result = (img.width > 0) && (img.height > 0);
			resolve(result);
		};
		img.onerror = function () {
			resolve(false);
		};
		img.src = "data:image/webp;base64," + kTestImages[feature];
	});
}

/*export class MobileDetect {
	static Android = navigator.userAgent.match(/Android/i);
	static BlackBerry = navigator.userAgent.match(/BlackBerry/i);
	static iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
	static Opera = navigator.userAgent.match(/Opera Mini/i);
	static Windows = navigator.userAgent.match(/IEMobile/i);
	static Any = MobileDetect.Android || MobileDetect.BlackBerry || MobileDetect.iOS || MobileDetect.Opera || MobileDetect.Windows;
}*/



// WEBPACK FOOTER //
// ./core/utils/utils.js